import { SURVEY_YEAR } from "../kpiConfiguration";
import { fetchCompanyDetail, fetchNogaDetail} from "./dataFetching";

const EMPTY_ARRAY = [];

function extractActiveFilters(keyFiguresFilters, filterId, isInitialLoad) {
  if (isInitialLoad) return EMPTY_ARRAY;

  const filter = keyFiguresFilters?.filters?.find((item) => item.id === filterId);
  
  if (filter.id === "greaterRegion") {
    let items = filter.items.filter((e) => e.active).map((e) => e.name);

    return items;
  }

  if (!filter) return EMPTY_ARRAY;

  return (filter.items || []).filter((item) => item.active).map((item) => item.id);
}

export function extractRequestBodyFromFilters(keyFiguresFilters, isInitialLoad) {
  return {
    years: [SURVEY_YEAR],
    nogaCodes: extractActiveFilters(keyFiguresFilters, "nogaCode", isInitialLoad),
    officeSizeIds: extractActiveFilters(keyFiguresFilters, "officeSize", isInitialLoad),
    greaterRegions: extractActiveFilters(keyFiguresFilters, "greaterRegion", isInitialLoad),
  };
}

async function setInitialActiveNoga(filtersCopy, languageKey, nogaFilterIndex, companyAccess) {
  let onError = (err) => console.log(err);
  let companyDetail = await fetchCompanyDetail(onError, companyAccess);
  let { nogaId } = companyDetail.data[0];
  let nogaDetails = await fetchNogaDetail(languageKey, nogaId, onError);
  let { nogaCode } = nogaDetails.data;
  if (nogaFilterIndex !== -1) {
    filtersCopy.filters[nogaFilterIndex].items = filtersCopy.filters[nogaFilterIndex].items.map((option) => ({
      ...option,
      active: option.id === nogaCode,
    }));
    const noActiveNogas = filtersCopy.filters[nogaFilterIndex].items.every((item) => !item.active);
    if (noActiveNogas) {
      activateDefaultNogaCode(filtersCopy, nogaFilterIndex);
    }
  }
  return filtersCopy;
}

function activateDefaultNogaCode(filtersCopy, nogaFilterIndex) {
  const ARCHI_OFFICE_NOGA_CODE = 711101;
  filtersCopy.filters[nogaFilterIndex].items = filtersCopy.filters[nogaFilterIndex].items.map((option) => ({
    ...option,
    active: option.id === ARCHI_OFFICE_NOGA_CODE,
  }));
  return filtersCopy;
}

function updateFilterItems(filtersCopy, filter, submittedFilters, nextAvailableFilters, translate) {
  const options = filtersCopy.allAvailabeFilters[filter.id] || [];
  const availableIds = nextAvailableFilters[filter.id] || [];

  return options.map((item) => {
    let dropDownOption = {};
    if (filter.id === "nogaCode") {
      dropDownOption = {
        ...item,
        active: submittedFilters[filter.id].includes(item.id),
      };
      return dropDownOption;
    }
    if (filter.id === "officeSize") {
      dropDownOption = {
        ...item,
        active: submittedFilters[filter.id].includes(item.id),
      };
      return dropDownOption;
    }
    if (filter.id === "surveyYears") {
      dropDownOption = { id: item, label: item, active: submittedFilters[filter.id].includes(item) };
      return dropDownOption;
    }
    if (filter.id === "greaterRegion") {
      dropDownOption = {
        ...item, 
        active: submittedFilters[filter.id].includes(item.name),
      };
      return dropDownOption;
    }
  });
}

export async function updateFilters(filters, submittedFilters, nextAvailableFilters, isInitialLoad, companyAccess, languageKey, translate) {
  let filtersCopy = { ...filters };

  if (isInitialLoad) {
    filtersCopy.allAvailabeFilters = nextAvailableFilters;
  }

  filtersCopy.filters = filtersCopy.filters.map((filter) => {
    let filterCopy = { ...filter };
    filterCopy.items = updateFilterItems(filtersCopy, filter, submittedFilters, nextAvailableFilters, translate);
    return filterCopy;
  });

  let nogaFilterIndex = filtersCopy.filters.findIndex((e) => e.id === "nogaCode");

  if (isInitialLoad && companyAccess) {
    filtersCopy = await setInitialActiveNoga(filtersCopy, languageKey, nogaFilterIndex, companyAccess);
    return { ...filtersCopy, newest: true, isInitialLoad: false };
  } else if (isInitialLoad && !companyAccess) {
    filtersCopy = activateDefaultNogaCode(filtersCopy, nogaFilterIndex);
    return { ...filtersCopy, newest: true, isInitialLoad: false };
  }
  return { ...filtersCopy, newest: false, isInitialLoad: false };
}
